import styled from 'styled-components';
import { Media, Colors } from 'enums';

export const Chip = styled.div`
  box-sizing: border-box;
  height: 30px;
  background-color: ${Colors.gray4};
  display: flex;
  width: fit-content;
  justify-content: center;
  align-items: center;
  padding: 12px 14px;
  gap: 10px;
  border-radius: 6px;

  @media ${Media.notebook} {
    height: 40px;
    padding: 8px 14px;
  }
`;

export const CloseIcon = styled.img`
  display: flex;
  width: 20px;
  height: 20px;

  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }

  @media ${Media.notebook} {
    width: 24px;
    height: 24px;
  }

  @media ${Media.desktop} {
    height: 40px;
    padding: 8px 16px;
  }
`;
